import type { FieldErrors, FieldValues } from 'react-hook-form'
import { getErrorFieldNames, type FieldNameMap } from '../utils/forms/get-error-field-names'
import useFlashMessages from './use-flash-messages'

export interface UseFormValidationErrorsOptions {
  /**
   * Optional map of field paths to display names, use it to customize how field names appear in error messages.
   * example: { configurationId: 'Configuration', imageId: 'VM Image' }
   */
  fieldNameMap?: FieldNameMap
}

/**
 * hook that returns an error handler for react-hook-form.
 */
const useFormValidationErrors = <TFieldValues extends FieldValues = FieldValues>(
  flash: ReturnType<typeof useFlashMessages>,
  options?: UseFormValidationErrorsOptions
) => {
  return (errors: FieldErrors<TFieldValues>) => {
    flash.clear()
    const errorFieldNames = getErrorFieldNames<TFieldValues>(errors, options?.fieldNameMap)

    if (errorFieldNames.length === 0) return

    const fieldList = errorFieldNames.join(', ')
    flash.error({ message: `Please fix the following fields: ${fieldList}` })
  }
}

export default useFormValidationErrors
